import { RestClientAuthenticated } from '../network';

import {
  RattachementDemand,
  RattachementDemandeCreation,
  RattachementDemandEntite,
  RattachementDemandePersonne,
} from './types/RattachementDemand';
import { StatutEnum } from './types/compte/CompteProfilProProfileDetails';

const rattachementDemandApi = {
  getRattachementDemand: (): Promise<RattachementDemandEntite> => new RestClientAuthenticated('/rattachement-demands', 'GET')
    .execute(),
  getPersonne: (rattachementDemandId: number): Promise<RattachementDemandePersonne> => new RestClientAuthenticated(`/rattachement-demands/${rattachementDemandId}/personne`, 'GET')
    .execute(),
  validateRattachement: (rattachementDemandId: number, statut: StatutEnum): Promise<void> => new RestClientAuthenticated(`/rattachement-demands/${rattachementDemandId}/validate`, 'POST', null)
    .jsonBody({ statut })
    .execute(),
  create: (rattachementDemandeCreation: RattachementDemandeCreation): Promise<void> => new RestClientAuthenticated('/rattachement-demands', 'POST', null)
    .jsonBody(rattachementDemandeCreation)
    .execute(),
  refuse: (rattachementDemandId: number): Promise<void> => new RestClientAuthenticated(`/rattachement-demands/${rattachementDemandId}`, 'DELETE', null)
    .execute(),
  getCurrentUserDemands: (): Promise<RattachementDemand[]> => new RestClientAuthenticated('/rattachement-demands/my-rattachement-demands', 'GET')
    .execute(),
  delete: (rattachementDemandId: number): Promise<void> => new RestClientAuthenticated(`/rattachement-demands/${rattachementDemandId}/delete`, 'DELETE', null)
    .execute(),
};
export default rattachementDemandApi;
